import { render, staticRenderFns } from "./AccountCreationCard.vue?vue&type=template&id=32d4fcdb&scoped=true"
import script from "./AccountCreationCard.vue?vue&type=script&lang=js"
export * from "./AccountCreationCard.vue?vue&type=script&lang=js"
import style0 from "./AccountCreationCard.vue?vue&type=style&index=0&id=32d4fcdb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d4fcdb",
  null
  
)

export default component.exports